import { render, staticRenderFns } from "./GridBackground.vue?vue&type=template&id=0cbed398&scoped=true&"
import script from "./GridBackground.vue?vue&type=script&lang=js&"
export * from "./GridBackground.vue?vue&type=script&lang=js&"
import style0 from "./GridBackground.vue?vue&type=style&index=0&id=0cbed398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbed398",
  null
  
)

export default component.exports